"use client";

import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function KitchenProjectCtaBand() {
  return <section id="kitchenprojectctaband" data-nav="dark" className="relative overflow-hidden bg-secondary text-secondary-foreground border-y border-white/10 py-16 sm:py-20">
      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-secondary-foreground max-w-2xl leading-tight">
            Ready to start your Brookhaven kitchen project?
          </h2>

          <div className="h-[1px] w-16 bg-primary/60 my-5" aria-hidden="true" />

          <p className="text-secondary-foreground/80 text-base sm:text-lg max-w-xl font-default leading-relaxed mb-8">
            Schedule a design consultation to explore bespoke cabinetry, custom layouts, and transparent project timelines tailored to your home.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full max-w-md">
            <motion.div whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-medium px-7 shadow-sm transition-colors">
                <Link to="/ContactRequestAnEstimatePage">
                  Request an Estimate
                </Link>
              </Button>
            </motion.div>

            <a href="tel:+14708479076" className="inline-flex items-center justify-center gap-2 text-sm sm:text-base font-medium text-secondary-foreground hover:text-primary transition-colors py-2 px-3 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50">
              <Phone className="size-4 text-primary shrink-0" aria-hidden="true" />
              <span>Call (470) 847-9076</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}